import axios from "axios";
import {
  COURSES_LOADING,
  GET_ALL_ASSIGNMENT_DOCUMENTS,
  GET_ASSIGNMENT_DOCUMENTS_BY_COURSE_AND_USER,
  GET_INDIVIDUAL_ASSIGNMENT_DOCUMENT,
} from "./types";
import { SnackBar } from "../../reusableComponents/SnackbarConfig";
import history from "../../reusableComponents/history";

export const uploadAssignmentDocument = (data) => (dispatch) => {
  axios
    .post("/api/assignmentDocuments/uploadAssignmentDocument", data)
    .then((res) => {
      const { message } = res?.data;
      SnackBar.success(message);
      dispatch(
        getAssignmentDocumentsByCourseAndUser(data.courseId, data.userId)
      );
      // history.push(`/admin/course/${data.courseId}`);
    })
    .catch((err) => {
      const { message } = err?.response?.data;
      SnackBar.error(message);
    });
};

export const getAllAssignmentDocuments = (courseId) => (dispatch) => {
  dispatch(coursesLoading());
  axios
    .get(`/api/assignmentDocuments/getAssignmentDocuments`)
    .then((res) => {
      dispatch({
        type: GET_ALL_ASSIGNMENT_DOCUMENTS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      const { message } = err?.response?.data;
      SnackBar.error(message);
    });
};

export const getIndividualAssignmentDocument = (id) => (dispatch) => {
  dispatch(coursesLoading());
  axios
    .get(`/api/assignmentDocuments/getIndividualAssignmentDocument/${id}`)
    .then((res) => {
      dispatch({
        type: GET_INDIVIDUAL_ASSIGNMENT_DOCUMENT,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      const { message } = err?.response?.data;
      SnackBar.error(message);
    });
};
export const getAssignmentDocumentsByCourseAndUser =
  (courseId, userId) => (dispatch) => {
    dispatch(coursesLoading());
    axios
      .get(
        `/api/assignmentDocuments/getAssignmentDocumentsByCourseAndUser/${courseId}/${userId}`
      )
      .then((res) => {
        dispatch({
          type: GET_ASSIGNMENT_DOCUMENTS_BY_COURSE_AND_USER,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        const { message } = err?.response?.data;
        SnackBar.error(message);
      });
  };

export const coursesLoading = () => {
  return {
    type: COURSES_LOADING,
  };
};
